import React from 'react';
import { Trans } from 'react-i18next';
import CeoMessageSection2Image1 from '../../assets/ceo_message_section2_image1.png';
import CeoMessageSection2Image2 from '../../assets/ceo_message_section2_image2.png';
import { HorizontalEqualLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, H3, Text1 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

interface LineItemProps {
  index: string;
  description: string;
}

const LineItem: React.FC<LineItemProps> = ({ index, description }) => {
  const { isMobile, isTablet, isDesktop } = useDeviceType();
  return (
    <VerticalLayout wrapContents={true}>
      <VerticalLayout height={1} backgroundColor="#00000044" />
      <BTBox height={14} />
      <HorizontalLayout wrapContents={true}>
        <Text1 style={{ width: isMobile ? '50px' : '150px' }}>{index}</Text1>
        <Text1 style={{ flex: 1 }}>{description}</Text1>
      </HorizontalLayout>
      <BTBox height={pxToRem(98)} />
    </VerticalLayout>
  );
};


const CEOMessageSection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : pxToRem(270)} />
      <H3 style={{
        ...isChina ? {wordBreak: 'break-word'} : {}
      }}>
        <Trans i18nKey="비비테크 홈페이지를 방문해 주신 여러분께 진심으로 감사드립니다." />
      </H3>
      <BTBox height={pxToRem(131)} />
      <HorizontalEqualLayout style={{
        width: '100%',
        alignItems: isMobile ? 'stretch' : 'start',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row', // ✅ 모바일=세로, 데스크톱=가로
        gap: isMobile ? pxToRem(24) : undefined,    // (선택) 모바일 간격
      }}>
        <VerticalLayout>
          <img src={CeoMessageSection2Image1} style={{ width: isMobile ? '100%' : '90%' }} />
          <div style={{ height: isMobile ? '1px' : '2px', width: isMobile ? '100%' : '80%', backgroundColor: 'black' }} ></div>
          {isMobile && (
            <BTBox height={30} />
          )}
        </VerticalLayout>
        <VerticalLayout>
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='당사는 지난 20여 년간 반도체 및 이차전지 산업을 중심으로 특수 배관과 클린룸 설계·시공 분야에서 정밀하고 안전한 엔지니어링 솔루션을 제공해 왔습니다.' />
          </Body1>
          <BTBox height={pxToRem(40)} />
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='“Making the world brighter with Technology”라는 사명(使命)을 가슴에 품고, 단 한 라인의 배관에도 더 나은 미래를 담겠다는 각오로 현장을 누벼왔습니다.' />
          </Body1>
          <BTBox height={pxToRem(40)} />
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='고객의 니즈를 정확히 이해하고, 산업 현장에서 요구하는 수준 이상의 품질을 실현하기 위해 끊임없는 기술 고도화와 현장 중심의 개선을 이어오고 있습니다.' />
          </Body1>
          <BTBox height={pxToRem(40)} />
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='비비테크는 기술은 결국 사람을 위한 것이라는 신념을 바탕으로 배관, 설비, 시공을 넘어 ‘더 나은 삶을 위한 연결’ 을 만들어가고자 합니다.' />
          </Body1>
          <BTBox height={pxToRem(40)} />
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='고객이 안심하고 기술을 맡길 수 있는 파트너, 사용자가 진심으로 만족할 수 있는 결과물, 구성원이 자부심을 느낄 수 있는 일터가 되기 위해 오늘도 우리는 현장에서 진심을 다합니다.' />
          </Body1>
          <BTBox height={pxToRem(40)} />
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='비비테크는 이러한 가치를 실천함으로써 고객과의 신뢰를 쌓고, 산업과 사회가 함께 성장하는 기반을 만들어가고자 합니다.' />
          </Body1>
          <BTBox height={pxToRem(40)} />
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='앞으로도 “한 걸음씩, 그러나 가장 정확하게” 나아가며, 기술을 넘어 신뢰를 전하는 엔지니어링 파트너로 성장해 나가겠습니다.' />
          </Body1>
          <BTBox height={pxToRem(40)} />
          <Body1 style={{ ...isMobile ? { fontSize: isEng ? '16px' : '18px', lineHeight: isEng ? '26px' : '30px', opacity: 0.6, fontWeight: 700 } : { opacity: 0.6 } }}>
            <Trans i18nKey='감사합니다.' />
          </Body1>
        </VerticalLayout>
      </HorizontalEqualLayout>
      <BTBox height={pxToRem(40)} />
      <div style={{ width: '100%', textAlign: 'right' }}>
        <Body1 style={{ ...isMobile ? { fontSize: '18px', lineHeight: '44px', fontWeight: 700, opacity: 0.8 } : { fontWeight: 700, opacity: 0.8 } }}>
          <Trans i18nKey='대표이사 성진규' />
        </Body1>
      </div>
      <div style={{ width: '100%', textAlign: 'right' }}>
        <img src={CeoMessageSection2Image2} style={{ width: isMobile ? '163px' : '326px' }} />
      </div>

      <BTBox height={isMobile ? 82 : pxToRem(157)} />

    </VerticalLayout>
  );
};

export default CEOMessageSection2;
